import { SizeDropdownMenu } from './dropdown-menu';

export * from './dropdown-menu';

export function effects() {
  customElements.define('hive-size-dropdown-menu', SizeDropdownMenu);
}
